import { twMerge } from 'tailwind-merge'
import { motion } from 'framer-motion'
import {
  animateStateOpacityRotation,
  animateStateOpacityScale,
  exitStateOpacityRotation,
  exitStateOpacityScale,
  initialStateOpacityRotation,
  initialStateOpacityScale,
  springMotion,
  springMotionLowStiffness,
  whileHover,
  whileTap,
} from 'lib/framer-motion-constants'

export default function SvgButtonTransparent({
  id,
  className,
  children,
  active,
  onClick,
}: {
  id?: string
  className?: string
  children?: React.ReactNode
  active?: boolean
  onClick?: () => void
}) {
  const iconColor = active ? 'text-accent-light' : 'text-primary-light'
  return (
    //@ts-ignore
    <motion.button
      id={id}
      className={twMerge('w-7 h-7 lg:opacity-30 ' + iconColor, className)}
      onClick={onClick}
      initial={initialStateOpacityScale}
      animate={animateStateOpacityScale}
      exit={exitStateOpacityScale}
      whileHover={whileHover}
      whileTap={whileTap}
      transition={springMotionLowStiffness}
    >
      {children}
    </motion.button>
  )
}
